/**
 * New Schedule page
 * Create a new recurring scrape schedule
 */

import { PageHeader } from '@/components/common/PageHeader';
import { ScheduleWizard } from '@/components/schedules';

export function NewSchedulePage() {
  return (
    <div>
      <PageHeader
        title="Create New Schedule"
        breadcrumbs={[
          { label: 'Dashboard', path: '/' },
          { label: 'Schedules', path: '/schedules' },
          { label: 'New Schedule' },
        ]}
      />

      <ScheduleWizard />
    </div>
  );
}

export default NewSchedulePage;
